// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"65":"115a1da3","856":"720bde4e"}[chunkId] + ".js";
};